export default {
    messages: {},
    attributes: {
        paymentType: "payment type",
        paymentMethod: "payment method",
        cardholderName: "name on card",
        cardNumber: "card number",
        expiryMonth: "expiry month",
        expiryYear: "expiry year",
        paymentStatus: "payment status",
        jobNumber: "job number",
        paymentState: "payment state",
        firstName: "first name",
        mobileNumber: "mobile number",
        address1: "address",
    }
};